export const terms = {
  header: {
    badge: "Informations légales",
    title: "Conditions d'utilisation",
  },
  content: {
    intro:
      "Bienvenue sur DONKEY TRAVEL. Les présentes conditions d'utilisation encadrent l'accès et l'utilisation de notre plateforme d'échange de logements. En utilisant nos services, vous acceptez ces conditions dans leur intégralité.",
    eligibility: {
      title: "1. Éligibilité et Inscription",
      text: "L'accès au club DONKEY TRAVEL est strictement réservé aux hôtes disposant d'une annonce active sur des plateformes reconnues (comme Airbnb) avec une note globale minimale de 4,5 sur 5. Toute falsification de ces critères entraînera la suppression immédiate du compte sans remboursement de l'abonnement.",
    },
    subscription: {
      title: "2. Abonnement et Paiements",
      text: "L'utilisation complète de la plateforme nécessite la souscription à notre forfait Annuel. Les paiements sont sécurisés et traités par des prestataires tiers. L'abonnement est renouvelable tacitement à moins d'une annulation par l'utilisateur.",
    },
    exchanges: {
      title: "3. Fonctionnement des échanges",
      text: "Les échanges au sein du club reposent sur la confiance et le respect mutuel. Les accords d'échange se font directement entre les membres via notre messagerie interne. Un contrat d'échange moral et, le cas échéant, légal, est conclu entre les deux parties.",
    },
    responsibilities: {
      title: "4. Engagements et Responsabilités",
      text: "Chaque membre s'engage à présenter son logement de manière transparente, avec des photos récentes et descriptifs exacts. Le membre hôte s'assure de l'hygiène impeccable du lieu. Le membre visiteur s'engage à respecter scrupuleusement le logement et son règlement intérieur. DONKEY TRAVEL agit en tant que facilitateur et n'est pas partie prenante aux contrats d'échange entre les membres. Nous déclinons toute responsabilité en cas de dommages, litiges ou annulations de dernière minute, bien que nous puissions intervenir en médiation.",
    },
    termination: {
      title: "5. Suspension et Résiliation",
      text: "DONKEY TRAVEL se réserve le droit de suspendre ou bannir tout membre ne respectant pas les règles de bonne conduite de la communauté, accumulant de mauvais retours, ou enfreignant ces conditions, et ce, de façon unilatérale.",
    },
    contact: {
      title: "6. Droit applicable et Litiges",
      text: "Ces conditions sont régies par la loi française. En cas de désaccord, les parties s'engagent à rechercher une solution amiable avant toute action en justice devant les tribunaux compétents. Pour toute question, nous contacter à legal@donkey.travel.",
    },
  },
};
